import Axios from 'axios';

class VariantViewApi {

    constructor() {
        this.api = Axios.create({
            baseURL: '/api/ProductVariant',
            timeout: 10000
        });
    }

    async GetGroupedVariants({ variantMotherPlid, templateId, groupByAttribute }) {
        try {
            const params = {
            variantMotherPlid,
            ...(templateId && { sid: templateId }),
            ...(groupByAttribute && { groupBy: groupByAttribute })
        };

            const response = await this.api.get('/GetGroupedVariants', { params });
            return response;
        } catch (error) {
            console.error('Error fetching variants:', error);
            throw error;
        }
    }
}

export default new VariantViewApi();